import React from 'react';
import { Box, Button, Slider, Typography } from '@mui/material';

const SelectFlexTimerange = ({
    handleNext,
    handleBack,
    flexibilityDays,
    setFlexibilityDays,
}) => {
    const handleSliderChange = (event, newValue) => {
        setFlexibilityDays(newValue);
    };

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                Select Flexibility Time Range
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                Choose the time period that will be used for model training and forecasting calculations.
                This defines the timeframe the model will analyze, not the window during which flexibility shifts occur.
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
                Select the number of days:
            </Typography>
            <Slider
                value={flexibilityDays}
                onChange={handleSliderChange}
                aria-labelledby="flexibility-slider"
                valueLabelDisplay="auto"
                step={1}
                marks={[
                    { value: 1, label: '1 day' },
                    { value: 2, label: '2 days' },
                    { value: 3, label: '3 days' },
                    { value: 4, label: '4 days' },
                    { value: 5, label: '5 days' },
                    { value: 6, label: '6 days' },
                    { value: 7, label: '7 days' },
                ]}
                min={1}
                max={7}
                sx={{ mt: 2, mb: 4 }}
            />
            <Box sx={{ mt: 2 }}>
                <Button onClick={handleBack} variant="text">
                    Back
                </Button>
                <Button onClick={handleNext} variant="outlined" color="primary" sx={{ ml: 2 }}>
                    Next
                </Button>
            </Box>
        </Box>
    );
};

export default SelectFlexTimerange; 